import CardGrid from 'emerald-ui/lib/CardGrid';
import Card from 'emerald-ui/lib/Card';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: CardGrid, componentName: 'CardGrid' }], 'CardGrid'),
  description: 'The CardGrid helps organize a group of cards.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Card, CardGrid },
      code: `<CardGrid>
  <Card>
    <h1 className="eui-card-title">Registered Nurse</h1>
    <h2 className="eui-card-subtitle">
      The best nurse I&#39;ve ever seen
    </h2>
    <p>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec
      odio. Quisque volutpat mattis eros. Nullam malesuada erat ut
      turpis. Suspendisse urna nibh, viverra non, semper suscipit,
      posuere a, pede.
    </p>
  </Card>
  <Card>
    <h1 className="eui-card-title">Registered Nurse</h1>
    <h2 className="eui-card-subtitle">
      The best nurse I&#39;ve ever seen
    </h2>
    <p>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec
      odio. Quisque volutpat mattis eros. Nullam malesuada erat ut
      turpis. Suspendisse urna nibh, viverra non, semper suscipit,
      posuere a, pede.
    </p>
  </Card>
  <Card>
    <h1 className="eui-card-title">Registered Nurse</h1>
    <h2 className="eui-card-subtitle">
      The best nurse I&#39;ve ever seen
    </h2>
    <p>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec
      odio. Quisque volutpat mattis eros. Nullam malesuada erat ut
      turpis. Suspendisse urna nibh, viverra non, semper suscipit,
      posuere a, pede.
    </p>
  </Card>
  <Card>
    <h1 className="eui-card-title">Registered Nurse</h1>
    <h2 className="eui-card-subtitle">
      The best nurse I&#39;ve ever seen
    </h2>
    <p>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec
      odio. Quisque volutpat mattis eros. Nullam malesuada erat ut
      turpis. Suspendisse urna nibh, viverra non, semper suscipit,
      posuere a, pede.
    </p>
  </Card>
</CardGrid>`,
    },
  ],
};
